import firebase from 'firebase';
import { db, storage } from './firebase';
import { firestoreKeys } from '../utils/constants';

// ----------------------------------------------------------------------

export default function useReviewService() {
  const createReview = (data) =>
    db.collection(firestoreKeys.REVIEWS).add({
      ...data,
      meta: {
        createdDate: firebase.firestore.FieldValue.serverTimestamp(),
        modifiedDate: firebase.firestore.FieldValue.serverTimestamp(),
      },
    });

  const uploadProfilePicture = async (file) => {
    const storageRef = storage.ref();
    const fileRef = storageRef.child(`profilePictures/${file.name}`);
    await fileRef.put(file);
    return fileRef.getDownloadURL();
  };

  return { createReview, uploadProfilePicture };
}
